/* eslint-disable import/first */
import React, { useState, useEffect, useCallback } from 'react';
import {
  Checkbox,
  FormControlLabel,
  Button,
  Box,
  List,
  ListItem,
  Avatar,
  ListItemText,
  Radio,
  ListItemSecondaryAction,
  Grid,
} from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import { Redux, Slices } from 'spwa-ui-library';
import { FormattedMessage } from 'react-intl';
import Skeleton from 'react-loading-skeleton';
import SavedCardView from './SavedCardView';
import DialogBox from '../../../components/DialogBox';
import BinPromotion from './BinPromotion';
const { fetchSavedCards } = Slices.homeSlice;
const { selectPaymentMethodConstants } = Slices.configSlice;
/* eslint-disable import/first */
const { useSelector, useDispatch } = Redux;
import PayonDelivery from './PayonDelivery';
import css from './index.module.scss';
import { getCurrentProfile } from 'spwa-ui-library/esm/redux/store/profileSlice';
import PopUpHeading from '../../../components/PopUpHeading';

const PaymentMethodList = ({
  isDesktop,
  paymentOpen,
  handlePaymentDrawer,
  paymentApiStatus,
  paymentMethod,
  handlePayment,
  iconList,
  paymentHeading,
  paymentMode,
  setPaymentOpen,
  makePayment,
  selectedValue,
  checked,
  handleChangeCheckbox,
  disableMakePayment,
  handleCardToken,
  cardToken,
  setCardNumber,
  setSubPayment,
  closePaymentPopup,
  checkLightningPay,
  toggleLighteningPayHandler,
  countryLightningPayStatus,
  lightningPayMaxAmount,
  currency,
}) => {
  const [cards, setCards] = useState([]);
  const [selectedMode, setSelectedMode] = useState(paymentMode);
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);
  const [selectedCard, setSelectedCard] = useState('');
  const [cardMethodAvailable, setCardMethodAvailable] = useState(false);
  const currentProfile = useSelector(getCurrentProfile);
  const [binPromoPopup, setBinPromoPopup] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [binSavedCard, setBinSavedCard] = useState(null);
  const paymentMethodConst = useSelector(selectPaymentMethodConstants);
  const promoObj = cart.data.promo || {};
  const enableBinPromo = promoObj?.noonPayPromoid && promoObj?.noonPayPromoid !== '' ? true : false;
  const handleSelectedCard = (tokenId, cardNumber) => {
    if (!enableBinPromo) {
      setSelectedCard(tokenId);
      setCardNumber(cardNumber);
      handlePayment(null);
      handleCardToken(tokenId);
      setSelectedMode(null);
    } else {
      setBinSavedCard({ tokenId, cardNumber });
      setSelectedMethod(1);
      setBinPromoPopup(true);
    }
  };

  useEffect(() => {
    if (selectedMode === 1 && cardToken) {
      setSelectedCard('');
    }
  }, [cardToken, selectedMode]);

  const fetchCardListHandler = () => {
    dispatch(fetchSavedCards())
      .then((res) => {
        setCards(res?.payload?.data?.data?.userCards);
      })
      .catch((err) => console.log('Saved Cards Error', err));
    setSelectedCard(cardToken);
    if (paymentMethod.length > 0) {
      setCardMethodOption();
    }
  };

  useEffect(() => {
    fetchCardListHandler();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardToken, cards?.length, dispatch, paymentMethod, selectedCard]);

  const setCardMethodOption = useCallback(() => {
    let cardMethod = paymentMethod.filter((each) => {
      return each.name === 'CARD';
    });
    setCardMethodAvailable(cardMethod[0]?.active ? true : false);
  }, [paymentMethod]);
  // eslint:fix empty array with paymentMethod is added to remove useCallback eslint:fix

  const fetchPaymentMethodName = (id) => {
    const op = paymentMethodConst.filter((each) => {
      return each.name === id;
    });
    return op[0].value;
  };

  const onClickPodRadio = (id, other) => {
    if (!enableBinPromo) {
      setSelectedCard('');
      setCardNumber(null);
      handleCardToken('');
      setSelectedMode(id);
      handlePayment(id);
    }
  };
  const updatePayment = (event, id) => {
    if (event) {
      setSelectedCard('');
      handleCardToken('');
      setCardNumber(null);
      if (enableBinPromo && id === 1) {
        event.preventDefault();
        setSelectedMode(id);
        handlePayment(id);
      } else if (!enableBinPromo) {
        event.preventDefault();
        setSelectedMode(id);
        handlePayment(id);
      } else {
        setSelectedMethod((prev) => id);
        setBinPromoPopup(true);
      }
    }
  };

  const handleSelectedMode = (id) => {
    // setSelectedCard('');
    // handleCardToken('');
    setSelectedMode(id);
    handlePayment(id);
  };
  // eslint:fix renderTermsList  function is created to remove duplciate code
  const renderTermsList = (list) => {
    return list.filter((method) => {
      const name = method?.name?.toLowerCase();

      return (
        name === 'card' ||
        name === 'visa_checkout' ||
        name === 'cod' ||
        name === 'knet' ||
        (name === 'apple_pay' && isIOS) ||
        name === 'ccod'
      );
    });
  };
  var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  useEffect(() => {
    paymentMethod
      .filter((method) => {
        const name = method?.name?.toLowerCase();

        return (
          name === 'card' ||
          name === 'visa_checkout' ||
          name === 'cod' ||
          name === 'knet' ||
          (name === 'apple_pay' && isIOS)
        );
      })
      .every((value, index) => {
        if (cardToken === '' && selectedMode === null) {
          if (value.id === 1 && selectedValue === 'future') {
            handleSelectedMode(value.id);
            return false;
          } else if (value.default === 1 && !enableBinPromo) {
            handleSelectedMode(value.id);
            return false;
          } else if (value.id === 1 && enableBinPromo) {
            handleSelectedMode(value.id);
            return false;
          }
        } else {
          if (enableBinPromo && value.id === cart.data.promo.paymentMethod) {
            handleSelectedMode(value.id);
            return false;
          } else if (value.default && !enableBinPromo) {
            handleSelectedMode(value.id);
            return false;
          }
        }
        return true;
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentMethod]);
  console.log(selectedMode, cardToken, 'Mode');
  const disablePaymentHandler = () => {
    if (currentProfile.phnVerified === 0 && (selectedMode === 100 || selectedMode === 0)) {
      return true;
    } else {
      return disableMakePayment;
    }
  };
  const titleDesc = (
    <h3 style={{ display: 'flex', justifyContent: 'center' }}>
      <FormattedMessage id="checkout_paymentmethod" defaultMessage="Select Payment Method" />
    </h3>
  );
  return (
    <div className={cards?.length > 0 ? css.paymentDrawer : css.paymentDrawerNocard}>
      {!isDesktop && <PopUpHeading heading={titleDesc} onClose={closePaymentPopup} />}
      <div className={css.methods}>
        <Grid className={css.paymentContainer}>
          {cards?.length > 0 && cardMethodAvailable && (
            <React.Fragment>
              <Grid>
                <Grid className={css.savedCardsText}>
                  {cards && cards?.length}{' '}
                  <FormattedMessage id="checkout_savedCards" defaultMessage="SAVED CARDS" />
                </Grid>
                <SavedCardView
                  cardList={cards}
                  checkLightningPay={checkLightningPay}
                  handleSelectedCard={handleSelectedCard}
                  cardToken={cardToken}
                  countryLightningPayStatus={countryLightningPayStatus}
                  lightningPayMaxAmount={lightningPayMaxAmount}
                  toggleLighteningPayHandler={toggleLighteningPayHandler}
                  currency={currency}
                  fetchCardListHandler={fetchCardListHandler}
                />
              </Grid>
              <Divider {...(isDesktop ? { orientation: 'vertical', flexItem: true } : {})} />
            </React.Fragment>
          )}
          <div className={css.payment}>
            <div className={css.paymentList}>
              {cards?.length > 0 && cardMethodAvailable && (
                <h2>
                  <FormattedMessage
                    id="checkout_paymentmethod"
                    defaultMessage="Select Payment Method"
                  />
                </h2>
              )}
              {!paymentApiStatus && (
                <Box sx={{ padding: '10px' }}>
                  <Skeleton count={5} className={css.Skeleton} height={56} />
                </Box>
              )}
              <List>
                {renderTermsList(paymentMethod).map((value, index) => {
                  if (!value.active) {
                    return '';
                  }
                  if (value.id === 100 && selectedValue === 'future') {
                    return '';
                  }
                  if (value.id === 0 && selectedValue === 'future') {
                    return '';
                  }

                  return (
                    <>
                      {value.name === 'COD' ? (
                        <PayonDelivery
                          selectedValue={selectedValue}
                          setSubPayment={setSubPayment}
                          paymentMethodConst={paymentMethodConst}
                          paymentModeObj={paymentMethod}
                          onClickPodRadio={onClickPodRadio}
                          checked={selectedMode === value.id}
                          id={value.id}
                        />
                      ) : (
                        <ListItem
                          onClick={(event) => updatePayment(event, value.id)}
                          className={css.paymentItem}
                          key={value.name}
                          button
                          component="label"
                        >
                          <Avatar
                            variant="square"
                            alt={value.name}
                            src={iconList[value.name]}
                            className={css.image}
                          />
                          <ListItemText
                            // primary={paymentHeading[value.name]}
                            primary={fetchPaymentMethodName(value.name)}
                            className={css.methodTitle}
                          />
                          <ListItemSecondaryAction className={css.radio}>
                            <Radio
                              edge="end"
                              value={value.id}
                              checked={
                                (!cardToken || cardToken === 'null' || cardToken === 'undefined') &&
                                selectedMode === value.id
                              }
                              onClick={(event) => updatePayment(event, value.id)}
                            />
                          </ListItemSecondaryAction>
                        </ListItem>
                      )}
                    </>
                  );
                })}
              </List>
            </div>
            {/* <div className={css.savedCards}>{isDesktop && <h2>Saved Cards</h2>}</div> */}
          </div>
        </Grid>
        <div className={css.paymentButton}>
          <div className={css.contactLess}>
            <FormControlLabel
              control={<Checkbox checked={checked} onChange={handleChangeCheckbox} />}
              color="primary"
              label={
                <FormattedMessage
                  id="preferred_payment"
                  defaultMessage="Make this my preferred method."
                />
              }
            />
          </div>
          <div className={css.submitButton}>
            <Button
              variant="outlined"
              className={css.cancelBtn}
              size="large"
              onClick={closePaymentPopup}
            >
              <FormattedMessage id="checkout_cancel" defaultMessage="Cancel" />
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="large"
              onClick={makePayment}
              disabled={disablePaymentHandler()}
            >
              <FormattedMessage id="checkout_payment" defaultMessage="Make Payment" />
            </Button>
          </div>
        </div>
      </div>
      {binPromoPopup && (
        <>
          <DialogBox
            isOpen={binPromoPopup}
            titleId={''}
            description={''}
            onClose={() => {
              setBinPromoPopup(false);
            }}
          >
            <BinPromotion
              cardList={cards}
              binSavedCard={binSavedCard}
              setSelectedCard={setSelectedCard}
              setCardNumber={setCardNumber}
              handleCardToken={handleCardToken}
              makePayment={makePayment}
              paymentMethod={paymentMethod}
              setBinPromoPopup={setBinPromoPopup}
              setSelectedMethod={setSelectedMethod}
              selectedMethod={selectedMethod}
              setSelectedMode={setSelectedMode}
              handlePayment={handlePayment}
            />
          </DialogBox>
        </>
      )}
    </div>
  );
};

export default PaymentMethodList;
